module.exports = __webpack_public_path__ + "vue_assets/img/img_preorder_background.4da9c145.png";